import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepQuienesSomos from "../../FormularioPropuestaV2/steps/StepQuienesSomos";

const SeccionQuienesSomos = ({ formik, faltantes }) => (
  <SeccionWrapper
    id="seccion-quienes-somos"
    numero={2}
    titulo="Quiénes somos"
    faltantes={faltantes}
  >
    <StepQuienesSomos formik={formik} />
  </SeccionWrapper>
);

SeccionQuienesSomos.propTypes = {
  formik: PropTypes.object.isRequired,
  faltantes: PropTypes.arrayOf(PropTypes.string),
};

export default SeccionQuienesSomos;
